<div class="file-upload">
    <input type="file" #fileInput [attr.multiple]="allowMultiple ? true : null" [attr.accept]="allowedFileTypes" (change)="onFilesSelected($event)"
        style="display: none;" />
</div>